// extracted by css-extract-rspack-plugin
export default {"container":"Content-module__container__XNeQq","toolbar":"Content-module__toolbar__Ce9fq","pagination":"Content-module__pagination__n1lXi"};